<boi-session-end [titleLabel]="referenceDataLabels.LoggedOut"
    [descriptionLabel]="referenceDataLabels.ToAccessYourAccount">
</boi-session-end>